<template>
    <div class="page-confirmation">
        <div class="confirm-box box-max-w clearfix">
            <p class="remark tl" v-html="coupon.activity_detail"></p>
            <div class="confirm-text bold">
                <div class="confirm-coupon">
                    <p class="confirm-title">確認啟動優惠券</p>
                    <p v-html="coupon.detail"></p>
                    <p>確認到{{coupon.name}}使用現金券？</p>
                </div>
                <div class="exchange-store">
                    <img :src="coupon.logo" :alt="coupon.name"/>
                </div>
            </div>
            <form @submit.prevent="sendSMS">
                <div class="confirm-link-box">
                    <button class="btn tc" :class="{'btn-loading': is_loading}">確認</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import smsService from '../service/smsService'
const CustomEvent = require('custom-event');

export default {
    name: "confirm",
    props:{
        coupon: {
            type: Object,
            default: {}
        }
    },
    data(){
        return {
            is_loading: false,
        }
    },
    methods: {
        sendSMS(){
            if(this.is_loading) return;
            this.is_loading = true;

            smsService.send({
                phone: this.coupon.phone,
                id: this.coupon.id
            })
            .then( resp => {
                if(resp.status){
                    history.pushState({}, '', 'thankyou');
                    document.dispatchEvent(new CustomEvent("pageChange", {
                        detail: {
                            vPath: location.pathname
                        }
                    }));
                    this.$emit('nextstep');
                }else{
                    let err = resp.error
                    if(err.validate){
                        const first = Object.values(err.validate).find( item => item && item.length );
                        alert(first[0]);
                    }else{
                        alert(err.msg);
                    }
                }
            })
            .finally(() => {
                this.is_loading = false;
            })
        }
    }
}
</script>